<template>

    <div class="header">
      <div class="header_left">
        <img src="../../assets/HYLogo.jpg" alt="" class="header_left_logo">
        <div class="header_left_title">
          <div class="header_left_title_cn">固定资产管理系统</div>
          <div class="header_left_title_en">FIXED ASSET MANAGEMENT SYSTEM</div>
        </div>
      </div>

      <div class="header_right">
        <div class="header_right_name">{{userName}}</div>
        <div class="header_right_other">∨</div>
        <div>
          <el-avatar icon="el-icon-user-solid"></el-avatar>
        </div>
      </div>
    </div>

</template>

<script>
  import Cookies from "js-cookie";
  export default {
     name: 'Header',
     data () {
       return {
         userName
       }
     },
    created(){
      this.GetData();
    },
		// 这个页面真没啥可说的就是把名字显示了出来
     methods:{
        GetData(){
            this.userName = Cookies.get("UserName");
        }
     }
   }
</script>

<style lang="less">
  .header {
    height: 72px;
    background: #FFFFFF;
    box-shadow: 0px 2px 1px 0px rgba(209,210,213,0.8);
    border-radius: 0px 0px 0px 0px;
    opacity: 1;
    display: flex;
    justify-content: space-between;

    .header_left {
      // margin-top: 13px;
      display: flex;
      justify-content: start;
      .header_left_logo {
        margin-top: 8px;
        height: 54px;
        width: 54px;
      }
      .header_left_title {
        display: flex;
        flex-direction: column;
        margin-top: 8px;

        .header_left_title_cn {
          font-size: 27px;
          color: #4285F4;
          font-weight: bold;
        }
        .header_left_title_en {
          font-size: 12px;
          color: #465B65;
          // font-weight: bold;
        }
      }
    }

    .header_right {
      display: flex;
      justify-content: start;
      margin-top: 12px;

      .header_right_name {
        line-height: 42px;
        font-size: 18px;
        color: #687682;
        margin-right: 5px;
      }

      .header_right_other {
        line-height: 42px;
        // font-weight: 1000;
        font-size: 18px;
        margin-right: 5px;
        // color: #D1D2D5;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Tool/Header.vue